module.exports = __webpack_public_path__ + "img/dark-mode-6682.efa94c5e.svg";